<template>
  <div class="page">

    <div class="intro-block">
      <div class="bg-left"></div>
      <a class="product-pack" target="_blank" href="http://espumisan.ru/instructions/espumizan-extra/index.phtml?utm_source=Afisha&utm_medium=Branding&utm_campaign=Espumisan_adults_2018"
         @click="$ga.event('Ссылки', 'Продукт в шапк, внутр', 1)">
        <img src="../assets/img/pack.png" alt=""></a>
      <div class="bg-right"></div>
      <div class="afishaLink">
        <a @click="$ga.event('Ссылка', 'Афиша', 1)" href="https://www.afisha.ru/"  target="_blank"><span class="afisha"></span></a>
      </div>
      <div class="shareBlock">
        <share-block></share-block>
      </div>
      <div class="container flex-b-center">
        <div class="photo" data-aos="fade-right"><img src="../assets/img/svetlana/intro.png" alt=""></div>
        <div class="info" data-aos="fade-left">
          <router-link to="/" class="back">назад</router-link>
          <h1 class="name">Светлана,</h1>
          <h4 class="age">30 лет</h4>
          <div class="line"></div>
          <div class="sub-text">
            Время летит незаметно! Кажется, еще вчера Света с Катей вместе ходили в школу
            и обсуждали мальчишек, а сегодня лучшая
            подруга выходит замуж. Катя выходит из своей комнаты настоящей красавицей: скромный макияж, аккуратно
            уложенные волосы
            и элегантное атласное платье на бретельках,
            что девушки купили буквально в последний момент.
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="image-container" data-aos="fade-up">
        <img src="../assets/img/svetlana/1.png" alt="">
      </div>
      <div class="quote" data-aos="flip-left">
        <div class="line"></div>
        <div class="text">И что Светлана видит на плече? Жуткую татуировку! «Свет, нравится? Это сюрприз для Пашки!»
          Света в ужасе — как жениху может понравиться это перекошенное сердечко…
        </div>
        <div class="line"></div>
      </div>
      <question :data="this.question1" @correct="q1=true" data-aos="fade-left"/>
      <Product data-aos="zoom-in"></Product>
      <div v-if="q1">
      <div class="content-block" data-aos="fade-up">
        <div class="content-block-image" >
          <img src="../assets/img/svetlana/2.jpg" alt="">
        </div>
        <div class="content-block-text">
          Ну вот и церемония в загсе. Среди толпы Света видит своего бывшего парня, да еще не одного,
          а с девушкой. Постойте, это же
          та коллега, которая всегда была
          его «подругой». Света испытывает большое желание выяснить отношения…
        </div>
      </div>

      <question :data="this.question2" @correct="q2=true" data-aos="fade-right"/>
      </div>
      <div v-if="q2">
      <p>Официальная часть подошла к концу. В ресторане началось самое веселье.</p>
      <div class="quote" data-aos="flip-left">
        <div class="line"></div>
        <div class="text">Шампанское льется рекой. Неудивительно,
          что через несколько бокалов у Светы начались проблемы с животом, и ни у кого нет под рукой ничего от вздутия.
          Ведущий просит девушку сказать тост в честь молодых,
          но ее откровенно пучит.
        </div>
        <div class="line"></div>
      </div>

      <question :data="this.question3" @correct="q3=true" data-aos="fade-left"/>
      </div>
      <div v-if="q3">

      <ReadMore data-aos="fade-up" :persons="['maria', 'elena']"/>
      </div>
    </div>
    <WarningBlock/>
  </div>

</template>

<script>
import "../assets/scss/page.scss";
import ShareBlock from "@/components/ShareBlock.vue";
import Question from "../components/Question";
import Product from "../components/Product";
import ReadMore from "../components/ReadMore";
import WarningBlock from "../components/WarningBlock";

export default {
  name: "Svetlana",
  components: {
    ShareBlock,
    Question,
    Product,
    ReadMore,
    WarningBlock
  },
  mounted() {
    document.body.classList.remove("modal-open");
    this.$ga.event("Страница", `Светлана`, 1);
  },
  data() {
    return {
      q1: false,
      q2: false,
      q3: false,
      question1: {
        n: 1,

        image: require("../assets/img/svetlana/question-1.png"),
        css: "svetlana",
        reversed: false,
        title: "Что ответить?",
        variants: [
          {
            title: "1. Не твое тело — не твое дело.",
            text:
              "О вкусах можно поспорить в другой день, а сегодня великий день, и не стоит невесте портить настроение.",
            correct: true
          },
          {
            title: "2. В смысле — татуировка? Ей что, пятнадцать? ",
            text:
              "Ей что, пятнадцать? Сейчас вместо загса мы поедем стирать эту дрянь с руки.",
            correct: false
          }
        ],
        wrong: {
          title: "Негодование подруги переросло в скандал",
          text:
            "Катя обвинила Свету, что у той нет вкуса и она совсем плохо знает жениха Пашу — он будет в восторге! Катя плачет, Света расстраивается \n" +
            "и уходит с праздника. "
        },
        correct: {
          text:
            "Переборов чувство отвращения, Светлана сказала подруге, \n" +
            "что та выглядит красавицей, \n" +
            "и они поехали в загс."
        }
      },
      question2: {
        n: 2,

        image: require("../assets/img/svetlana/question-2.png"),
        css: "svetlana",
        reversed: true,
        title: "Как поступить?",
        variants: [
          {
            title: "1. Да у него ни совести, ни воспитания! ",
            text:
              "Надо подойти к нему и попросить покинуть помещение вместе со своей «мочалкой».",
            correct: false
          },
          {
            title: "2. Лучше никому не портить праздник",
            text: "Захочет поздороваться — сам подойдет. ",
            correct: true
          }
        ],
        wrong: {
          title: "«Мочалка» вцепилась в волосы Свете…",

          text:
            "Из загса девушек вывела охрана, а Кате стало так стыдно, что она попросила подругу уйти с глаз долой."
        },
        correct: {
          text:
            "За трогательными признаниями в любви и клятвами Света совсем забыла о своем гневе и всю церемонию вытирала слезы радости за подругу. "
        }
      },
      question3: {
        n: 3,

        image: require("../assets/img/svetlana/question-3.png"),
        css: "svetlana",
        reversed: false,
        title: "Что делать?",
        variants: [
          {
            title: "1. Попытаться справиться со вздутием",
            text: "и сказать подготовленную речь.",
            correct: false
          },
          {
            title: "2. Рассказать невесте о недомогании",
            text:
              "и попросить ведущего перенести речь \n" +
              "на полчаса позже, чтобы успеть сбегать \n" +
              "до аптеки. ",
            correct: true
          }
        ],
        wrong: {
          title: "",
          text:
            "Вздутие живота побороть не удалось, в животе предательски заурчало, \n" +
            "а источник звуков выдал себя сразу пунцовыми щеками. Тихие смешки пошли по всему ресторану, кто-то из гостей начал снимать видео выступления Светланы. Кажется, кто-то станет звездой ютьюба. Светлана расстроилась и после речи незаметно убежала \n" +
            "со свадьбы в слезах.\n"
        },
        correct: {
          text:
            " Аптека оказалась в двух шагах. Уже через пару минут Светлане стало заметно лучше, и она вернулась \n" +
            "в ресторан. Тост был искренним и нежным. Невеста расплакалась, поблагодарила Светлану и назвала \n" +
            "ее самым близким человеком. Эти свадьбы — сплошные слезы!",
          style: {
            fontSize: "40px"
          }
        }
      }
    };
  }
};
</script>

<style scoped lang="scss">
  .product-pack{
    left: 3vw;
    top: 21vh;
  }
.bg-left {
  position: absolute;
  left: 0;
  left: 0;
  top: 0;
  background: url("../assets/img/svetlana/bg-left.png");
  height: 100%;
  width: 40%;
  background-repeat: no-repeat;
  z-index: -1;
  background-size: contain;
}

.bg-right {
  position: absolute;
  right: 0;
  top: 0;
  background: url("../assets/img/svetlana/bg-right.png");
  height: 100%;
  width: 40%;
  background-repeat: no-repeat;
  z-index: -1;
  background-size: contain;
  background-position: top right;
}
@media screen and (max-width: 768px) {
  .bg-left {
    background-image: url("../assets/img/svetlana/bg-left-mobile.png");
  }
  .bg-right {
    background-image: url("../assets/img/svetlana/bg-right-mobile.png");
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Svetlana.vue